var React = require('react');

function WaterIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.076,6.378l-.407-.29.407.29L14,.863l3.924,5.516.407-.29-.407.29a4.419,4.419,0,0,1-.558,5.783,4.9,4.9,0,0,1-6.732,0A4.419,4.419,0,0,1,10.076,6.378Zm-.9,14a4.419,4.419,0,0,1-.558,5.783,4.9,4.9,0,0,1-6.732,0,4.419,4.419,0,0,1-.558-5.783l-.407-.29.407.29L5.25,14.863l3.924,5.516.407-.29Zm17.5,0a4.419,4.419,0,0,1-.558,5.783,4.9,4.9,0,0,1-6.732,0,4.419,4.419,0,0,1-.558-5.783l-.407-.29.407.29,3.924-5.516,3.924,5.516.407-.29Z","transform":"translate(0.176)","fill":"none","stroke":"#383a36","strokeWidth":"1"}));
}

WaterIcon.defaultProps = {"width":"28.352","height":"28","viewBox":"0 0 28.352 28"};

module.exports = WaterIcon;

WaterIcon.default = WaterIcon;
